<script>
    import { onMount, onDestroy } from "svelte";
    import { modal } from '../store/nav';

    import { users } from "../store/users";

    export let user_uid;
    
    let user;

    console.log(user_uid);
    onMount(async ()=>{
        user = await users.find( user_uid );
    });
    onDestroy(async ()=>{
        users.save([user]);
        users.init();
    });
</script>

<section >
    {#if user}
        <section class="text-primary flex flex-col space-y-6">
            <section class="flex">
                <div class="bg-primary rounded-2xl w-12 h-12 shrink-0" on:click|stopPropagation={()=>console.log(user)}>
                    <img class="m-auto w-8 h-8 mt-2" src="/img/profiles/{user.type}.png" alt="">
                </div>
                <input class="ml-1.5 border-b border-shade w-32 text-center capitalize" type="text" id="user_name" on:focus={user.name=""} bind:value={user.name}>
            </section>
            <section class="flex space-x-2">
                <span>Is a/an </span>
                <select class="border border-shade px-2 rounded-sm w-24 capitalize text-sm italic" id="user_type" bind:value={user.type}>
                    <option value="user">Adult/Kid</option>
                    <option value="baby">Baby</option>
                    <option value="pet">Pet</option>
                </select>
            </section>
            <span>Dietary restrictions</span>
            <section class="flex space-x-2.5 flex-wrap">
                {#each user.diets as diets }
                    {#each Object.entries(diets) as [dietKey, dietValue] }
                        <span class:selected={diets[dietKey]} class="border border-shade mt-1.5 px-2 rounded-sm  min-w-16 capitalize text-sm italic place-self-center" on:click={()=>{diets[dietKey] = !dietValue }}>{dietKey}</span>
                    {/each}                
                {/each}
            </section>
            
            <section class="self-end text-shade italic text-sm" on:click={()=>{users.delete(user.uid);user=null;modal.close()}}>
                Delete
            </section>
        </section>
    {/if}
</section>
<style lang="postcss">
    .selected {
        @apply border-secondary text-secondary bg-primary;
    }
</style>